// Utility functions for cookie consent management

export const getCookieConsent = () => {
  try {
    const consent = localStorage.getItem('cookieConsent');
    return consent ? JSON.parse(consent) : null;
  } catch (error) {
    console.error('Error parsing cookie consent:', error);
    return null;
  }
};

export const hasConsent = (type) => {
  const consent = getCookieConsent();
  if (!consent) return false;
  
  switch (type) {
    case 'analytics':
      return consent.analytics === true;
    case 'marketing':
      return consent.marketing === true;
    case 'functional':
      return consent.functional === true;
    case 'necessary':
      return true; // Always true
    default:
      return false;
  }
};

export const loadAnalytics = () => {
  if (!hasConsent('analytics')) {
    console.log('Analytics cookies not consented, skipping Google Analytics');
    return false;
  }
  
  // Load Google Analytics
  try {
    // Initialize GA4
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
    return true;
  } catch (error) {
    console.error('Error loading analytics:', error);
    return false;
  }
};

export const loadMarketing = () => {
  if (!hasConsent('marketing')) {
    console.log('Marketing cookies not consented, skipping marketing scripts');
    return false;
  }
  
  // Load marketing scripts here if needed
  return true;
};

export const loadFunctional = () => {
  if (!hasConsent('functional')) {
    console.log('Functional cookies not consented, limiting functionality');
    return false;
  }
  
  // Load functional scripts here if needed
  return true;
};

// Initialize consent-based features
export const initializeConsentFeatures = () => {
  const consent = getCookieConsent();
  
  if (consent) {
    if (consent.analytics) {
      loadAnalytics();
    }
    if (consent.marketing) {
      loadMarketing();
    }
    if (consent.functional) {
      loadFunctional();
    }
  }
};

// Check if user has consented to analytics
if (hasConsent('analytics')) {
  // Load analytics features
}

if (hasConsent('marketing')) {
  // Load marketing features
} 